import { Effect } from "../Materials/effect";
var name = 'linePixelShader';
var shader = "uniform vec4 color;\nvoid main(void) {\ngl_FragColor=color;\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var linePixelShader = { name: name, shader: shader };
//# sourceMappingURL=line.fragment.js.map